import { create } from 'zustand'

export type ToastSeverity = 'success' | 'error' | 'info' | 'warning'

export interface Toast {
    id: string
    message: string
    severity: ToastSeverity
    duration?: number
}

interface ToastState {
    toasts: Toast[]
    show: (message: string, severity?: ToastSeverity, duration?: number) => void
    dismiss: (id: string) => void
}

export const useToastStore = create<ToastState>((set) => ({
    toasts: [],

    show: (message, severity = 'info', duration = 4000) => {
        set((state) => {
            if (state.toasts.some((t) => t.message === message && t.severity === severity)) {
                return state
            }
            const id = crypto.randomUUID()
            return { toasts: [...state.toasts, { id, message, severity, duration }] }
        })
    },

    dismiss: (id) => {
        set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }))
    },
}))
